import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import { NavbarMenuLink } from '@/components/elementary/navbar/NavbarMenuLink';
import { ArrowRight } from '@/components/icons/ArrowRight';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
import { NAVBAR_TEST_IDS } from '@/lib/test-ids';
import styles from './NavbarColumnGroup.module.css';
import navbarMenuLinkStyles from './NavbarMenuLink.module.css';
interface NavbarColumnGroupProps {
  readonly group: Data.Component<'layout-utilities.navbar-column-group'>;
  readonly columnTitle?: string | null;
  readonly testId?: string;
  readonly className?: string;
  onLinkClick?: () => void;
}
type Layout = 'default' | '2-columns' | '3-columns';
const layoutStyles: Record<Layout, string> = {
  default: 'gap-5 xl:gap-3',
  '2-columns': 'gap-4 xl:grid-cols-2 xl:gap-x-6 xl:gap-y-3',
  '3-columns': 'gap-4 xl:grid-cols-3 xl:gap-x-6 xl:gap-y-3'
};
export function NavbarColumnGroup(t0) {
  const $ = _c(25);
  const {
    group,
    columnTitle,
    testId,
    className,
    onLinkClick
  } = t0;
  const layout = ((group as {
    layout?: Layout;
  }).layout ?? "default") as Layout;
  const isMultiColumn = layout !== "default";
  let t1;
  if ($[0] !== className) {
    t1 = cn("grid gap-5 h-fit xl:pb-2 xl:last:pb-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== columnTitle) {
    t2 = columnTitle && <Paragraph fontSize="headingSubtitle" textColor="gray" className="uppercase xl:hidden">{columnTitle}</Paragraph>;
    $[2] = columnTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== group?.title) {
    t3 = group?.title && <Paragraph fontSize="headingMedium" className={styles["nav-group-title"]}>{group?.title}</Paragraph>;
    $[4] = group?.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = layoutStyles[layout];
  let t5;
  if ($[6] !== t4) {
    t5 = cn("grid", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== group?.links || $[9] !== isMultiColumn || $[10] !== onLinkClick) {
    t6 = group?.links?.map(link => <NavbarMenuLink key={link?.id} link={link} stackIcon={isMultiColumn} testId={NAVBAR_TEST_IDS.CATEGORY_COLUMN_LINK} onClick={onLinkClick} />);
    $[8] = group?.links;
    $[9] = isMultiColumn;
    $[10] = onLinkClick;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== group?.moreLink || $[16] !== onLinkClick) {
    t8 = group?.moreLink?.href && group?.moreLink?.title ? <AppLink link={group?.moreLink} variant="primaryLink" underline={true} className="w-fit" iconEnd={<ArrowRight className="size-3 xl:size-4 text-brand-black" />} data-test-id={NAVBAR_TEST_IDS.CATEGORY_COLUMN_SEE_MORE} onClick={onLinkClick}><Paragraph className={navbarMenuLinkStyles["nav-content-menu-arrow-link"]}>{group?.moreLink?.title}</Paragraph></AppLink> : null;
    $[15] = group?.moreLink;
    $[16] = onLinkClick;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t7 || $[22] !== t8 || $[23] !== testId) {
    t9 = <div data-test-id={testId} className={t1}>{t2}{t3}{t7}{t8}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
    $[23] = testId;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}